/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { B2CCard, greyMultibrandPalette, CustomTheme } from '@masfront/common-b2c'
import { subMonths } from 'date-fns'

import { Box, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import RechargesHistoryTable from './RechargesHistoryTable'

import { selectAgent } from '~/auth/store/auth.selectors'
import useBalance from '~/balance/hooks/useBalance'
import { makePathname } from '~/net'
import { PATHS } from '~/pages/router/paths'
import { B2CPage, ErrorMessage, CustomCircularProgress } from '~/ui/components'
import { formatDateToString } from '~/utils'

const useStyles = makeStyles((theme: CustomTheme) => {
  return {
    root: {
      backgroundColor: greyMultibrandPalette[50],
      minHeight: '90vh',
      padding: theme.spacing(6),
    },
    circularProgressWrapper: {
      top: 15,
      position: 'relative',
    },
  }
})

interface RechargesHistoryProps {
  subscriptionId: string
  customerIdentifier: string
  productId: string
}

const RechargesHistory: React.FC<RechargesHistoryProps> = ({
  customerIdentifier,
  productId,
  subscriptionId,
}) => {
  const classes = useStyles()

  const {
    getRecharges,
    getMoreRecharges,
    recharges,
    rechargesLoading,
    rechargesError,
  } = useBalance(subscriptionId)

  const { agent } = useSelector(selectAgent)

  const today = new Date()

  const goBackUrl = makePathname(PATHS.PRODUCT, { customerIdentifier, productId })

  useEffect(() => {
    getRecharges({
      subscriptionId,
      startDate: formatDateToString(subMonths(today, 6)),
      endDate: formatDateToString(today),
      sub: agent?.sub,
    })
  }, [])

  function loadMoreRecharges() {
    getMoreRecharges({
      subscriptionId,
      monthsToAdd: 3,
      sub: agent?.sub,
    })
  }

  return (
    <Box>
      <B2CPage goBackUrl={goBackUrl} title="Histórico de recargas" subtitle={productId}>
        <Box className={classes.root}>
          <B2CCard title="Detalle de recargas" dataHookPrefix="recharges">
            {rechargesLoading && (
              <Box display="flex" justifyContent="center" width="100%" pb={3}>
                <Box className={classes.circularProgressWrapper}>
                  <CustomCircularProgress size={75} />
                </Box>
              </Box>
            )}
            {recharges && (
              <Box px={2}>
                {recharges.length ? (
                  <RechargesHistoryTable recharges={recharges} />
                ) : (
                  !rechargesLoading && <ErrorMessage title="No hay recargas recientes." />
                )}
                <Box display="flex" mt={4} justifyContent="center">
                  <Button
                    data-hook="load-more-button"
                    onClick={loadMoreRecharges}
                    variant="outlined"
                    color="secondary"
                    size="small"
                  >
                    CARGAR MÁS MESES
                  </Button>
                </Box>
              </Box>
            )}
            {rechargesError && !recharges && (
              <Box my={20}>
                <ErrorMessage title="Ha ocurrido un error." />
              </Box>
            )}
          </B2CCard>
        </Box>
      </B2CPage>
    </Box>
  )
}

export default RechargesHistory
